// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2LWUo","empty":"ModalGraph_empty__1w6XE"};